const DEFAULT_INSTALLATION_NAME = 'Joyprotyn';

export const getInstallationName = () => {
  return window.globalConfig?.INSTALLATION_NAME || DEFAULT_INSTALLATION_NAME;
};

export const replaceChatwootBranding = value => {
  if (typeof value === 'string') {
    return value.replace(/Chatwoot/g, getInstallationName());
  }

  if (Array.isArray(value)) {
    return value.map(replaceChatwootBranding);
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [
        key,
        replaceChatwootBranding(nestedValue),
      ])
    );
  }

  return value;
};

export const getI18nBrandingPostProcessor = () => translated => {
  return replaceChatwootBranding(translated);
};
